import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaPhone, 
  FaWhatsapp, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaFacebook, 
  FaInstagram,
  FaTwitter,
  FaLinkedin,
  FaHeart 
} from 'react-icons/fa';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' },
  ];

  const servicesLinks = [
    { name: 'Home Nursing', path: '/services/home-nursing' },
    { name: 'Elderly Care', path: '/services/elderly-care' },
    { name: 'Physiotherapy', path: '/services/physiotherapy' },
    { name: 'Doctor Home Visit', path: '/services/doctor-visit' },
    { name: 'Lab Sample Collection', path: '/services/lab-collection' },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-r from-health-blue to-health-green rounded-full flex items-center justify-center">
                <span className="text-white text-xl font-bold">L</span>
              </div>
              <div>
                <h3 className="text-xl font-bold font-poppins">Lerito HealthCare</h3>
                <p className="text-sm text-gray-400">Home care, india</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6">
              Providing quality home care services at your doorstep.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaFacebook className="text-xl" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaInstagram className="text-xl" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaTwitter className="text-xl" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaLinkedin className="text-xl" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 font-poppins">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors flex items-center"
                  >
                    <span className="w-2 h-2 bg-health-blue rounded-full mr-3"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
         {/*  <div>
            <h3 className="text-lg font-bold mb-6 font-poppins">Our Services</h3>
            <ul className="space-y-3">
              {servicesLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors flex items-center"
                  >
                    <span className="w-2 h-2 bg-health-green rounded-full mr-3"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 font-poppins">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <FaPhone className="text-health-blue mt-1" />
                <div>
                  <p className="font-semibold">Phone Numbers</p>
                  <p className="text-gray-400">+91 8266958207</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <FaWhatsapp className="text-green-500 mt-1" />
                <div>
                  <p className="font-semibold">WhatsApp</p>
                  <p className="text-gray-400">+91 8266958207</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                {/* <FaMapMarkerAlt className="text-red-500 mt-1" /> */}
               {/*  <div>
                  <p className="font-semibold">Address</p>
                  <p className="text-gray-400">Main Road, Near Railway Station</p>
                  <p className="text-gray-400">Haridwar, Uttarakhand - 249401</p>
                </div> */}
              </li>
            </ul>
          </div>
        </div>

        {/* Emergency Banner */}
        <div className="mt-12 bg-gradient-to-r from-red-600 to-orange-600 rounded-xl p-6 text-center">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="mb-4 md:mb-0">
              <h4 className="text-xl font-bold">🚨 Medical Emergency?</h4>
              <p className="text-sm">Available 24/7 for immediate assistance</p>
            </div>
            <a
              href="tel:+918266958207"
              className="bg-white text-red-600 px-8 py-3 rounded-full font-bold hover:bg-gray-100 transition-colors"
            >
              Call Emergency: +91 8266958207
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-gray-800 py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} Lerito HealthCare & Home care, Haridwar. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-white text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white text-sm">
                Terms of Service
              </Link>
              <p className="text-gray-400 text-sm flex items-center">
                Made with <FaHeart className="text-red-500 mx-1" /> in india
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;